/**
 * Created by afuhr on 27.03.2017.
 */

export const helpTexts = {
  products: "Produkte"
};



// WEBPACK FOOTER //
// ./src/app/store-management/helptexts.ts